import { useState, useEffect } from 'react';
import { useLocaleStore } from '@/lib/core/stores';
import { getCatalogProducts } from './catalog';
import type { IApiContentResponseModel, ProductListItemDto } from '@/services/platform/api/model';
import type { ShopProductItem } from './types';

function mapProduct(p: ProductListItemDto): ShopProductItem {
  return {
    id: p.publicGuid ?? '',
    brand: p.vendor ?? undefined,
    name: p.title ?? undefined,
    price: p.price != null ? `€${p.price.toFixed(2)}` : undefined,
    image: p.imageUrl ?? undefined,
  };
}

export function useShopCollectionProducts(
  picker: IApiContentResponseModel[] | null | undefined,
  pageSize = 8
): { items: ShopProductItem[]; loading: boolean } {
  const locale = useLocaleStore(s => s.locale);
  const [items, setItems] = useState<ShopProductItem[]>([]);
  const [loading, setLoading] = useState(false);

  const ids = (picker ?? []).map(p => p.id).filter(Boolean) as string[];
  const idsKey = ids.join(',');

  useEffect(() => {
    if (ids.length === 0) {
      setItems([]);
      return;
    }
    let cancelled = false;
    setLoading(true);
    getCatalogProducts({ collection: ids, pageSize }, locale)
      .then(r => {
        if (!cancelled) setItems(r?.products?.items?.map(mapProduct) ?? []);
      })
      .catch(() => {
        if (!cancelled) setItems([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [idsKey, pageSize, locale]);

  return { items, loading };
}
